import axios from "./_axios";
import { API } from "./apiEndPoints";

export const SUGGEST_CONTEXT_FALLBACK_ERROR = "Context suggestion failed. Please try again.";

// ER-10218: read-only suggestion for one object (responsibility|role|position|department|account).
// The backend answers { suggestion } and stores nothing.
export const suggestContext = (objectType, objectId) => {
  return axios()({
    method: "post",
    url: API.SUGGEST_CONTEXT,
    data: { object_type: objectType, object_id: objectId },
  });
};

// ER-10219: preview the account context a set of user-typed URLs would produce.
// Like the object suggestion this stores nothing, including the URLs themselves.
export const suggestContextFromUrls = (urls, accountId) => {
  const data = { urls };
  if (accountId != null) {
    data.account_id = accountId;
  }
  return axios()({
    method: "post",
    url: API.SUGGEST_CONTEXT_ACCOUNT_FROM_URLS,
    data,
  });
};

export const getSuggestContextErrorMessage = (error) => {
  const detail = error?.response?.data?.detail;
  return typeof detail === "string" && detail.trim()
    ? detail.trim()
    : SUGGEST_CONTEXT_FALLBACK_ERROR;
};
